export enum MEDICAID_FEATUREABLE_TYPE {
  STATES = 'states',
  ORGANIZATIONS = 'organizations',
  PEOPLE = 'people',
}
